<template>
  <div class="layout single-select text-content">
    <div class="column">
      <h1 v-if="config.title" class="title">
        {{ $t(config.title, 'options.title') }}
      </h1>
      <div class="content-text" v-html="config.text"></div>
      <div class="actions">
        <a
          v-on:keyup.enter.stop="next"
          tabindex="1"
          role="button"
          :style="nextButtonStyle"
          @click.stop.prevent="next"
          class="next"
          key="next"
        >
          {{ $t(buttonText, 'config.buttonText') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate';
import Vue from 'vue';
import TranslationMixin from '../lib/TranslationMixin';

export default {
  name: 'SingleSelect',
  props: ['config'],
  inject: ['convince', 'theme'],
  mixins: [TranslationMixin],
  data: function() {
    return {
      currentSelection: null,
      complete: false,
    };
  },
  computed: {
    columnStyle() {
      return 'multi-select-columns-' + this.columnCount;
    },
    buttonStyle() {
      return {
        borderRadius: this.theme.borderRadius + 'px',
      };
    },
    buttonText() {
      return this.config.buttonText || 'Next';
    },
    nextButtonStyle() {
      return Object.assign(this.theme.accent, {
        borderRadius: this.theme.borderRadius + 'px',
      });
    },
  },
  methods: {
    next() {
      this.$store.commit('advance');
    },
    beforeEnter: function(el, done) {
      Velocity(
        el,
        { opacity: 0, translateY: '100%', translateZ: 0 },
        { duration: 0 }
      );
      var delay = 500 + el.dataset.index * 150;
      setTimeout(function() {
        Velocity(
          el,
          { opacity: 1, translateY: '0%', translateZ: 0 },
          { complete: done, duration: 550 }
        );
      }, delay);
    },
    mergeProperties(ob, newOb) {
      for (let prop in newOb) {
        Vue.set(ob, prop, newOb[prop]);
      }
    },
  },
  mounted() {
    this.currentSelection = null;
    window.scroll(0, 0);
  },
  created() {
    if (typeof this.config.columns !== 'undefined') {
      this.columnCount = this.config.columns;
    } else {
      this.columnCount = 1;
    }
  },
};
</script>

<style lang="scss">
@import '../scss/components/survey';
</style>
<style lang="scss" scoped>
.survey h1 {
  margin-bottom: 1rem;
}
.content-text {
  margin-bottom: 1rem;
}
a.next {
  max-width: 300px;
}
</style>
